import { render, staticRenderFns } from "./IntegridadeMaterialGenerico.vue?vue&type=template&id=18e2746e&scoped=true&"
import script from "./IntegridadeMaterialGenerico.vue?vue&type=script&lang=js&"
export * from "./IntegridadeMaterialGenerico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e2746e",
  null
  
)

export default component.exports